import { render, staticRenderFns } from "./MediabankCategoryEdit.vue?vue&type=template&id=253f41f6&"
import script from "./MediabankCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./MediabankCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports